const cocoonWrapper = $('.customizations, .customizations-fields-wrapper');

function run(context = 'body') {
  var els = $(context).find('[data-image-input]');
  if (els.length > 0) {
    require.ensure('../modules/image_input', function(require) {
      var ImageInput = require('../modules/image_input');
      els.each(function() {
        return new ImageInput(this);
      });
    });
  }
}

cocoonWrapper.on('cocoon:after-insert', () => {
  run(cocoonWrapper);
});

run();



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/image_input.initializer.js